
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class ClientFunctionTriggerView extends SiteEntityGrid<ClientFunctionInvocationRow, ClientFunctionGetModelResponse> {

        protected getColumnsKey() { return "Workflow.ClientFunctionInvocationHistory" }
        protected getIdProperty() { return ClientFunctionInvocationRow.Fields.RowId; }
        protected getLocalTextPrefix() { return ClientFunctionInvocationRow.localTextPrefix; }
        protected getService() { return ClientFunctionInvocationService.baseUrl; }
        protected getDialogType() { return ClientFunctionInvocationDialog; }

        private paramsGrid: Serenity.PropertyGrid;
        private paramsValidator: JQueryValidation.Validator;

        constructor(container: JQuery, opt: ClientFunctionGetModelResponse) {
            super(container, opt);

            if (this.options.Description) {
       
                this.titleDiv.append($("<div class='trigger-description grid-title-description'></div>")
                    .text(this.options.Description || ''))
            }

            this.setTitle(this.options.Title || this.options.TriggerCode);
        }

        protected getPersistanceKey() {
            return "ClientFunction:" + this.options.FunctionName;
        }

        protected onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            var request = (this.view.params as Serenity.ListRequest);
            if (!this.options.FunctionName)
                return false;

            request.EqualityFilter = request.EqualityFilter || {};
            request.EqualityFilter[ClientFunctionInvocationRow.Fields.FunctionName] = this.options.FunctionName;

            return true;
        }

        protected createQuickSearchInput() {
        }

        protected getButtons(): Serenity.ToolButton[] {
            var pickerButton = Serenity.ColumnPickerDialog.createToolButton(this);
            pickerButton.icon = "mdi mdi-table-column-plus-after";

            return [{
                title: this.options.ActionVerb || "Run Function",
                cssClass: 'execute-button',
                icon: 'fa-play-circle',
                onClick: () => {
                    if (!this.paramsValidator.form())
                        return;

                    var request: ClientFunctionInvokeRequest = {};
                    request.FunctionName = this.options.FunctionName;
                    request.Params = {};
                    this.paramsGrid.save(request.Params);
                    for (var p of this.options.Parameters) {
                        if (p.visible != null && !p.visible && p.defaultValue != null) {
                            request.Params[p.name] = p.defaultValue;
                        }
                    }

                    request.ParamTypes = {};
                    for (var p of this.options.Parameters) {
                        request.ParamTypes[p.name] = p.editorType as string;
                        if ((p.editorType == "FileUpload" ||
                            p.editorType == "ImageUpload"))
                            request.Params[p.name] = request.Params[p.name]  + ":" + (p.editorParams || {}).Source;
                    }

                    var success = () => {
                        Q.notifySuccess("The request has been queued.");
                        this.paramsGrid.load({});
                        this.paramsValidator && this.paramsValidator.resetForm();
                        this.refresh();
                    }

                    ClientFunctionTriggerView.Invoke(request, success);
                }
            },
                pickerButton,
              {
                    title: 'Refresh',
                  cssClass: 'refresh-button',
                    icon: 'fa-refresh',
                    onClick: () => this.reload && this.reload()
                }
            ];
        }

        protected reload() {
            this.refresh();
            this.element.triggerHandler('layout');

        }

        static Invoke(request: ClientFunctionInvokeRequest, success: () => void): void {
            ClientFunctionService.Invoke(request, success,
                {
                    onError: (response: Serenity.ServiceResponse) => {
                        if (response &&
                            response.Error &&
                            response.Error.Code == "ConfirmationRequired" &&
                            !request.ConfirmPending) {
                            Q.confirm(response.Error.Message, () => {
                                request.ConfirmPending = true;
                                ClientFunctionService.Invoke(request, success);
                            }, {
                                dialogClass: 's-WarningDialog',
                                title: 'Warning'
                            });
                        }
                        else
                            Q.ErrorHandling.showServiceError(response.Error);
                    }
                });
        }

        protected createQuickFilters() {
            super.createQuickFilters();

            var paramsDiv = $("<form class='flex-layout params-form'>" +
                "<h4 class='params-cap grid-sub-title'>Parameters<i class='expand-collapse mdi mdi-chevron-double-up' title='collapse'></i></h4>" +
                "<div class='s-Form' style='padding-top: 2px; padding-bottom: 3px'><div id='ReportParams'></div></div></form>")
                .insertBefore(this.quickFiltersDiv && this.quickFiltersDiv.length ?
                    this.quickFiltersDiv : this.slickContainer);

            var paramsToggle = () => {
                var ec = paramsDiv.find('.expand-collapse')
                    .toggleClass('mdi-chevron-double-up').toggleClass('mdi-chevron-double-down');
                var collapse = ec.hasClass('mdi-chevron-double-down');
                ec.attr('title', collapse ? 'expand' : 'collapse');
                ec.closest('form').children('div')
                    .toggleClass('hidden', collapse);
                localStorage.setItem('workflowTriggerParametersCollapsed', collapse ? "1" : "0");
                $(window).triggerHandler('resize');
                this.resizeCanvas();
            };

            paramsDiv.find('.expand-collapse').click((e) => paramsToggle());
            if (localStorage.getItem("workflowTriggerParametersCollapsed") == "1")
                paramsToggle();

            var prm = (this.options.Parameters || []).filter(x => x.visible == null || !!x.visible);
            for (var p of prm) {
                if (!p.title)
                    p.title = titleize(p.name || '');

                if (p.editorParams) {
                    if (p.editorParams.minValue === '')
                        delete p.editorParams.minValue;
                    if (p.editorParams.maxValue === '')
                        delete p.editorParams.maxValue;
                }
            }

            this.paramsGrid = new Serenity.PropertyGrid(
                paramsDiv.children('div').children(), {
                    items: this.options.Parameters || [],
                    idPrefix: this.uniqueName + '_'
                }
            );

            if (!this.options.Parameters || !this.options.Parameters.length)
                paramsDiv.hide();

            var initial = {};
            var query = Q.parseQueryString();
            for (var x of this.options.Parameters || []) {
                var paramValue = query[x.name];
                if (paramValue != null) {
                    var intValue = Q.parseInteger(paramValue);
                    initial[x.name] = !isNaN(intValue) ? intValue : paramValue;
                }
            }

            this.paramsGrid.load(initial);

            if (!this.options.Parameters || !this.options.Parameters.length)
                this.element.find('h4.params-cap').hide();

            if (this.quickFiltersDiv && this.quickFiltersDiv.length) {
                var quickFiltersCap = $("<h4 class='quick-cap grid-sub-title'>Quick Filters<i class='expand-collapse mdi-chevron-double-up' title='collapse'></i></h4>")
                    .insertBefore(this.quickFiltersDiv);

                var quickFiltersToggle = () => {
                    var ec = quickFiltersCap.find('.expand-collapse')
                        .toggleClass('mdi-chevron-double-up').toggleClass('mdi-chevron-double-down');
                    var collapse = ec.hasClass('mdi-chevron-double-down');
                    ec.attr('title', collapse ? 'expand' : 'collapse');
                    this.quickFiltersDiv.toggleClass('hidden', collapse);
                    localStorage.setItem('workflowTriggerQuickFiltersCollapsed', collapse ? "1" : "0");
                    $(window).triggerHandler('resize');
                    this.resizeCanvas();
                };

                quickFiltersCap.find('.expand-collapse').click((e) => quickFiltersToggle());
                if (localStorage.getItem("workflowTriggerQuickFiltersCollapsed") == "1")
                    quickFiltersToggle();
            }

            this.paramsValidator = this.paramsGrid.element.closest('form').validate(Q.validateOptions({}));
        }

        private mergeTitle() {
            return false;
        }
    }

    export function titleize(str: string) {
        var str_arr = str.split('_');
        for (var x = 0; x < str_arr.length; x++)
            str_arr[x] = str_arr[x].charAt(0).toUpperCase() + str_arr[x].substring(1).toLowerCase();
        return str_arr.join(' ');
    }
}